// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__32Pdk","label":"Radio_label__2_zLN","checkMark":"Radio_checkMark__185im","disabled":"Radio_disabled__9xqtw"};